import { Navigate, Route, Routes } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import PlanningPage from './pages/PlanningPage';
import DashboardPage from './pages/DashboardPage';
import AdminPage from './pages/AdminPage';
import TvDisplayPage from './pages/TvDisplayPage';
import ClientsPage from './pages/ClientsPage';
import AttentePiecesPage from './pages/AttentePiecesPage';
import AppShell from './components/AppShell';
import ProtectedRoute from './components/ProtectedRoute';
import { useAuthBootstrap } from './hooks/useAuth';

export default function App() {
  useAuthBootstrap();

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/tv" element={<TvDisplayPage />} />

      <Route
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Navigate to="/planning/service-rapide" replace />} />
        <Route path="/planning" element={<Navigate to="/planning/service-rapide" replace />} />
        <Route path="/planning/:type" element={<PlanningPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/clients" element={<ClientsPage />} />
        <Route path="/attente-pieces" element={<AttentePiecesPage />} />
        <Route
          path="/parametres"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminPage />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route
        path="*"
        element={
          <div className="flex h-screen items-center justify-center text-text-muted">
            404 — Page introuvable
          </div>
        }
      />
    </Routes>
  );
}
